export enum ProgramType {
  MEETUP_PROGRAM = "MEETUP_PROGRAM",
  IN_PERSON_MEETUP_PROGRAM = "IN_PERSON_MEETUP_PROGRAM",
  BUYERS_PROGRAM = "BUYERS_PROGRAM",
  TABLETALK_PROGRAM = "TABLETALK_PROGRAM",
  ASSOCIATED_PROGRAM = "ASSOCIATED_PROGRAM",
  TRADE_PROGRAM = "TRADE_PROGRAM",
  CONNECTIONS_PROGRAM = "CONNECTIONS_PROGRAM"
}

export const MeetupPrograms = [
  ProgramType.MEETUP_PROGRAM,
  ProgramType.IN_PERSON_MEETUP_PROGRAM,
  ProgramType.BUYERS_PROGRAM,
  ProgramType.TRADE_PROGRAM,
  ProgramType.CONNECTIONS_PROGRAM
];

export const TradeProgramsList = [ProgramType.TRADE_PROGRAM, ProgramType.CONNECTIONS_PROGRAM];

export const ProgramOrganizationsNavMenuIsAvailable = [
  ProgramType.TRADE_PROGRAM,
  ProgramType.CONNECTIONS_PROGRAM,
  ProgramType.BUYERS_PROGRAM,
  ProgramType.IN_PERSON_MEETUP_PROGRAM,
  ProgramType.MEETUP_PROGRAM
];

export const AllProgramTypeList: Array<ProgramType> = Object.values(ProgramType);

export const BuyerProgramsList = [ProgramType.BUYERS_PROGRAM, ProgramType.TRADE_PROGRAM];
export const NonAssociateProgramsList = AllProgramTypeList.filter(p => p !== ProgramType.ASSOCIATED_PROGRAM);
export const NonConnectionMeetupProgramsList = MeetupPrograms.filter(p => p !== ProgramType.CONNECTIONS_PROGRAM);

export const MeetingCapAllowedProgramList = [ProgramType.MEETUP_PROGRAM, ProgramType.TRADE_PROGRAM];
export const UnscheduledMeetingsPurchaseAllowedProgramsList = [ProgramType.MEETUP_PROGRAM, ProgramType.TRADE_PROGRAM];

export const AutoApprovalAllowedProgramList = [
  ProgramType.MEETUP_PROGRAM,
  ProgramType.TRADE_PROGRAM,
  ProgramType.TABLETALK_PROGRAM
];

export const ProfileSponsorAdsAllowedProgramList: Array<string | ProgramType> = [
  ProgramType.MEETUP_PROGRAM,
  ProgramType.TRADE_PROGRAM,
  ProgramType.BUYERS_PROGRAM,
  ProgramType.CONNECTIONS_PROGRAM,
  ProgramType.TABLETALK_PROGRAM
];
